import { render, staticRenderFns } from "./Publicity.vue?vue&type=template&id=6930eaca&scoped=true"
import script from "./Publicity.vue?vue&type=script&lang=js"
export * from "./Publicity.vue?vue&type=script&lang=js"
import style0 from "./Publicity.vue?vue&type=style&index=0&id=6930eaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930eaca",
  null
  
)

export default component.exports